import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

export default function TooltipWrapper({
  title,
  children,
  placement = "top",
  arrow = true,
  enterDelay = 100,
  leaveDelay = 0,
}: TooltipWrapperProps) {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow={arrow}
      TransitionComponent={Zoom}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
    >
      <span style={{ display: "inline-flex" }}>{children}</span>
    </Tooltip>
  );
}
interface TooltipWrapperProps {
  title: React.ReactNode;
  children: React.ReactElement;
  placement?:
    | "bottom"
    | "top"
    | "left"
    | "right"
    | "bottom-start"
    | "bottom-end"
    | "left-start"
    | "left-end"
    | "right-start"
    | "right-end"
    | "top-start"
    | "top-end";
  arrow?: boolean;
  enterDelay?: number;
  leaveDelay?: number;
}
